import React from "react";
import { useInputBon } from "./useInputBon";
import PopUpComponent from "../..//components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import moment from "moment";
import { formatDot } from "../../util/utilFunction";
import RupiahInput from "../../components/RupiahInput/RupiahInput";
import Select from "react-select";
import ApproveIcon from "../../Assets/approve-icon.png";
import CancelIcon from "../../Assets/cancel-icon.png";
import "./InputBon.css";

const InputBon = () => {
  const {
    dataUser,
    popUpNewItem,
    setPopUpNewItem,
    checkBoxNama,
    setCheckBoxNama,
    nominal,
    setNominal,
    keterangan,
    setKeterangan,
    namaBonInput,
    setNamaBonInput,
    isDisabled,
    setIsDisabled,
    handleKirimInputBon,
    isErr,
    setIsErr,
    selectNama,
    setSelectNama,
    listNamaBon,
    listBon,
  } = useInputBon();

  return (
    <div className="container_inventory">
      {popUpNewItem ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "12px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setCheckBoxNama("ada")}
            >
              <input
                className="checkbox-barang-jasa"
                type="checkbox"
                style={{ cursor: "pointer" }}
                checked={checkBoxNama === "ada"}
              />
              <label
                style={
                  !isErr
                    ? { cursor: "pointer" }
                    : { cursor: "pointer", color: "red" }
                }
              >
                Sudah Ada
              </label>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setCheckBoxNama("belum")}
            >
              <input
                className="checkbox-barang-jasa"
                type="checkbox"
                style={{ cursor: "pointer" }}
                checked={checkBoxNama === "belum"}
              />
              <label
                style={
                  !isErr
                    ? { cursor: "pointer" }
                    : { cursor: "pointer", color: "red" }
                }
              >
                Belum Ada
              </label>
            </div>
            <img
              className="width_edit_logo"
              src={CloseLogo}
              onClick={() => {
                setPopUpNewItem(false);
                setSelectNama();
                setNominal();
                setKeterangan();
                setNamaBonInput();
                setCheckBoxNama("");
                setIsDisabled(false);
                setIsErr(false);
              }}
              alt="edit_logo"
            />
          </div>

          <div>
            <div>
              <p
                style={
                  !isErr
                    ? { margin: "12px 0 6px 0" }
                    : { margin: "12px 0 6px 0", color: "red" }
                }
              >
                Nama
              </p>
              {checkBoxNama === "ada" ? (
                <Select
                  options={listNamaBon}
                  value={selectNama || ""}
                  onChange={setSelectNama}
                />
              ) : (
                <input
                  type="text"
                  className="input-nama-bon"
                  style={
                    !isErr
                      ? {
                          border: "1px solid #d1d5db",
                        }
                      : {
                          border: "1px solid red",
                        }
                  }
                  placeholder="Nama bon"
                  value={namaBonInput}
                  onChange={(e) =>
                    setNamaBonInput(e.target.value.toUpperCase())
                  }
                />
              )}
            </div>
          </div>

          <div>
            <p
              style={
                !isErr
                  ? { margin: "12px 0 6px 0" }
                  : { margin: "12px 0 6px 0", color: "red" }
              }
            >
              Nominal
            </p>
            <RupiahInput
              value={nominal}
              onChange={(angka) => setNominal(angka)}
              placeholder="Masukkan nominal"
              isErr={isErr}
            />
          </div>
          <div>
            <p
              style={
                !isErr
                  ? { margin: "12px 0 6px 0" }
                  : { margin: "12px 0 6px 0", color: "red" }
              }
            >
              Keterangan
            </p>
            <textarea
              className="textarea-keterangan-bon"
              style={
                !isErr
                  ? {
                      border: "1px solid #d1d5db",
                    }
                  : {
                      border: "1px solid red",
                    }
              }
              placeholder="Keterangan..."
              value={keterangan}
              onChange={(e) => setKeterangan(e.target.value.toUpperCase())}
            />
          </div>

          <br />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              className="button_popup background_red"
              disabled={isDisabled}
              onClick={() => {
                setIsDisabled(true);
                handleKirimInputBon();
              }}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <div className="wrapper_header">
        <p className="title_inventory">Input Bon</p>
        <div
          className="wrapper-button-tambah"
          onClick={() => setPopUpNewItem(true)}
        >
          <p className="button-tambah">+</p>
          <button className="text-button-tambah">New Bon</button>
        </div>
      </div>
      <div style={{ overflowX: "auto", marginTop: "12px" }}>
        <table
          style={{
            borderCollapse: "collapse",
            width: "100%",
          }}
        >
          <thead>
            <tr>
              <th className="thStyle" rowSpan={2}>
                No.
              </th>
              <th className="thStyle" rowSpan={2}>
                Item Bon
              </th>
              <th className="thStyle" rowSpan={2}>
                Nominal
              </th>
              <th className="thStyle" rowSpan={2}>
                Kategori
              </th>
              <th className="thStyle" rowSpan={2}>
                Pembuat
              </th>
              <th className="thStyle" rowSpan={2}></th>
            </tr>
          </thead>
          <tbody>
            {listBon &&
              listBon.map((item, i) => {
                return (
                  <tr
                    key={item.id || i}
                    style={
                      i % 2 === 0
                        ? {
                            background: "white",
                          }
                        : {
                            background: "#f2f2f2",
                          }
                    }
                  >
                    <td className="tdCenterStyle">{i + 1}.</td>
                    <td
                      className="tdCenterStyle"
                      style={{ whitespace: "nowrap" }}
                    >
                      {item.nama}
                    </td>
                    <td className="tdCenterStyle">
                      Rp. {formatDot(item.nominal)}
                    </td>
                    <td className="tdCenterStyle">{item?.kategori || ""}</td>
                    <td
                      className="tdCenterStyle"
                      style={{ lineHeight: "18px" }}
                    >
                      {item.creator} <br />
                      <span style={{ fontSize: "12px" }}>
                        {moment(item.timestamp)
                          .utcOffset(7)
                          .format("DD-MM-YYYY, HH:mm:ss")}
                      </span>
                    </td>
                    <td className="tdCenterStyle wrapper-approve-icon-bon">
                      <img src={CancelIcon} className="approve-icon-bon" />
                      <img src={ApproveIcon} className="approve-icon-bon" />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InputBon;
